import { useEffect } from 'react';
import { IFlightsEnrichmentData } from '../domain/models/IEnrichedFlight';
import { useFlightStores } from '../../context/flightStoresContext';

export function useSetFlightsEnrichmentData({
	airlines,
	airports,
}: IFlightsEnrichmentData) {
	const { airlineStore, airportStore } = useFlightStores();

	useEffect(() => {
		airlineStore.setAirlines(airlines);
		airportStore.setAirports(airports);
	}, []);
}
